export enum OrderStatusEnum {
    ALL = "ALL",
    PENDING = "PENDING",
    COMPLETED = "COMPLETED",
    EXPIRED = "EXPIRED",
    UNSUCCESSFUL = "UNSUCCESSFUL",
    CANCELLED = "CANCELLED"
}
